import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';

import { useTheme } from '@material-ui/core/styles';

import { cookieParamGraph, appadiddayGraph } from 'lib/api/datacenter';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';

import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

//광고쿠키통계
import CookieStatistics from './CookieStatistics';
import AudienceAdver from './AudienceAdver';

//앱모수타겟팅통계
import AppTargetingDailyStatistics from './AppTargetingDailyStatistics';
import AppTargetingMediaStatistics from './AppTargetingMediaStatistics';
import AppTargetingAdverStatistics from './AppTargetingAdverStatistics';

//데이터센터현황
import StatusStatistics from './StatusStatistics';

import AdidStatusStatistics from './AdidStatusStatistics';
import AppStatusStatistics from './AppStatusStatistics';
import AudienceStatistics from './AudienceStatistics';
import ConversionAudienceListStatistics from './ConversionAudienceListStatistics';

//App 필터링관리
import AppFiltering from './AppFiltering';
import { displayFilterList } from 'constants/resources/commonCustomize';

const DataCenter = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const cookieGraphList = [
    {
      title: t('누적'),
      data: {
        bar: [
          'ACC_LC',
          'ACC_TC',
          'ACC_WC',
          'ACC_MC',
          'ACC_CW',
          'ACC_OS',
          'ACC_CH',
          'ACC_CR',
          'ACC_PF',
          'ACC_HV',
          'ACC_HE',
          'ACC_TV',
          'ACC_WV',
          'ACC_MV',
          'ACC_RC',
          'ACC_SR',
          'ACC_TP',
          'ACC_WP',
          'ACC_SP',
          'ACC_HP',
          'ACC_HR',
          'ACC_TR',
          'ACC_RE',
          'ACC_WR',
          'ACC_FR',
          'ACC_HU',
          'ACC_UM',
          'ACC_PA',
          'ACC_AD',
          'ACC_US',
        ],
      },
      yAxisData: { left: { ACC_LC: true }, right: {} },
      customizeData: {
        ACC_LC: { color: theme.palette.graph.key.LC, required: true },
        ACC_TC: { color: theme.palette.graph.key.TC },
        ACC_WC: { color: theme.palette.graph.key.WC },
        ACC_MC: { color: theme.palette.graph.key.MC },
        ACC_CW: { color: theme.palette.graph.key.CW },
        ACC_OS: { color: theme.palette.graph.key.OS },
        ACC_CH: { color: theme.palette.graph.key.CH },
        ACC_CR: { color: theme.palette.graph.key.CR },
        ACC_PF: { color: theme.palette.graph.key.PF },
        ACC_HV: { color: theme.palette.graph.key.HV },
        ACC_HE: { color: theme.palette.graph.key.HE },
        ACC_TV: { color: theme.palette.graph.key.TV },
        ACC_WV: { color: theme.palette.graph.key.WV },
        ACC_MV: { color: theme.palette.graph.key.MV },
        ACC_RC: { color: theme.palette.graph.key.RC },
        ACC_SR: { color: theme.palette.graph.key.SR },
        ACC_TP: { color: theme.palette.graph.key.TP },
        ACC_WP: { color: theme.palette.graph.key.WP },
        ACC_SP: { color: theme.palette.graph.key.SP },
        ACC_HP: { color: theme.palette.graph.key.HP },
        ACC_HR: { color: theme.palette.graph.key.HR },
        ACC_TR: { color: theme.palette.graph.key.TR },
        ACC_RE: { color: theme.palette.graph.key.RE },
        ACC_WR: { color: theme.palette.graph.key.WR },
        ACC_FR: { color: theme.palette.graph.key.FR },
        ACC_HU: { color: theme.palette.graph.key.HU },
        ACC_UM: { color: theme.palette.graph.key.UM },
        ACC_PA: { color: theme.palette.graph.key.PA },
        ACC_AD: { color: theme.palette.graph.key.AD },
        ACC_US: { color: theme.palette.graph.key.US },
      },
    },
    {
      title: t('일일'),
      data: {
        bar: [
          'DAILY_LC',
          'DAILY_TC',
          'DAILY_WC',
          'DAILY_MC',
          'DAILY_CW',
          'DAILY_OS',
          'DAILY_CH',
          'DAILY_CR',
          'DAILY_PF',
          'DAILY_HV',
          'DAILY_HE',
          'DAILY_TV',
          'DAILY_WV',
          'DAILY_MV',
          'DAILY_RC',
          'DAILY_SR',
          'DAILY_TP',
          'DAILY_WP',
          'DAILY_SP',
          'DAILY_HP',
          'DAILY_HR',
          'DAILY_TR',
          'DAILY_RE',
          'DAILY_WR',
          'DAILY_FR',
          'DAILY_HU',
          'DAILY_UM',
          'DAILY_PA',
          'DAILY_AD',
          'DAILY_US',
        ],
      },
      yAxisData: { left: { DAILY_LC: true }, right: {} },
      customizeData: {
        DAILY_LC: { color: theme.palette.graph.key.LC, required: true },
        DAILY_TC: { color: theme.palette.graph.key.TC },
        DAILY_WC: { color: theme.palette.graph.key.WC },
        DAILY_MC: { color: theme.palette.graph.key.MC },
        DAILY_CW: { color: theme.palette.graph.key.CW },
        DAILY_OS: { color: theme.palette.graph.key.OS },
        DAILY_CH: { color: theme.palette.graph.key.CH },
        DAILY_CR: { color: theme.palette.graph.key.CR },
        DAILY_PF: { color: theme.palette.graph.key.PF },
        DAILY_HV: { color: theme.palette.graph.key.HV },
        DAILY_HE: { color: theme.palette.graph.key.HE },
        DAILY_TV: { color: theme.palette.graph.key.TV },
        DAILY_WV: { color: theme.palette.graph.key.WV },
        DAILY_MV: { color: theme.palette.graph.key.MV },
        DAILY_RC: { color: theme.palette.graph.key.RC },
        DAILY_SR: { color: theme.palette.graph.key.SR },
        DAILY_TP: { color: theme.palette.graph.key.TP },
        DAILY_WP: { color: theme.palette.graph.key.WP },
        DAILY_SP: { color: theme.palette.graph.key.SP },
        DAILY_HP: { color: theme.palette.graph.key.HP },
        DAILY_HR: { color: theme.palette.graph.key.HR },
        DAILY_TR: { color: theme.palette.graph.key.TR },
        DAILY_RE: { color: theme.palette.graph.key.RE },
        DAILY_WR: { color: theme.palette.graph.key.WR },
        DAILY_FR: { color: theme.palette.graph.key.FR },
        DAILY_HU: { color: theme.palette.graph.key.HU },
        DAILY_UM: { color: theme.palette.graph.key.UM },
        DAILY_PA: { color: theme.palette.graph.key.PA },
        DAILY_AD: { color: theme.palette.graph.key.AD },
        DAILY_US: { color: theme.palette.graph.key.US },
      },
    },
    {
      title: t('신규'),
      data: {
        bar: [
          'NEW_LC',
          'NEW_TC',
          'NEW_WC',
          'NEW_MC',
          'NEW_CW',
          'NEW_OS',
          'NEW_CH',
          'NEW_CR',
          'NEW_PF',
          'NEW_HV',
          'NEW_HE',
          'NEW_TV',
          'NEW_WV',
          'NEW_MV',
          'NEW_RC',
          'NEW_SR',
          'NEW_TP',
          'NEW_WP',
          'NEW_SP',
          'NEW_HP',
          'NEW_HR',
          'NEW_TR',
          'NEW_RE',
          'NEW_WR',
          'NEW_FR',
          'NEW_HU',
          'NEW_UM',
          'NEW_PA',
          'NEW_AD',
          'NEW_US',
        ],
      },
      yAxisData: { left: { NEW_LC: true }, right: {} },
      customizeData: {
        NEW_LC: { color: theme.palette.graph.key.LC, required: true },
        NEW_TC: { color: theme.palette.graph.key.TC },
        NEW_WC: { color: theme.palette.graph.key.WC },
        NEW_MC: { color: theme.palette.graph.key.MC },
        NEW_CW: { color: theme.palette.graph.key.CW },
        NEW_OS: { color: theme.palette.graph.key.OS },
        NEW_CH: { color: theme.palette.graph.key.CH },
        NEW_CR: { color: theme.palette.graph.key.CR },
        NEW_PF: { color: theme.palette.graph.key.PF },
        NEW_HV: { color: theme.palette.graph.key.HV },
        NEW_HE: { color: theme.palette.graph.key.HE },
        NEW_TV: { color: theme.palette.graph.key.TV },
        NEW_WV: { color: theme.palette.graph.key.WV },
        NEW_MV: { color: theme.palette.graph.key.MV },
        NEW_RC: { color: theme.palette.graph.key.RC },
        NEW_SR: { color: theme.palette.graph.key.SR },
        NEW_TP: { color: theme.palette.graph.key.TP },
        NEW_WP: { color: theme.palette.graph.key.WP },
        NEW_SP: { color: theme.palette.graph.key.SP },
        NEW_HP: { color: theme.palette.graph.key.HP },
        NEW_HR: { color: theme.palette.graph.key.HR },
        NEW_TR: { color: theme.palette.graph.key.TR },
        NEW_RE: { color: theme.palette.graph.key.RE },
        NEW_WR: { color: theme.palette.graph.key.WR },
        NEW_FR: { color: theme.palette.graph.key.FR },
        NEW_HU: { color: theme.palette.graph.key.HU },
        NEW_UM: { color: theme.palette.graph.key.UM },
        NEW_PA: { color: theme.palette.graph.key.PA },
        NEW_AD: { color: theme.palette.graph.key.AD },
        NEW_US: { color: theme.palette.graph.key.US },
      },
    },
  ];

  const adidGraphList = [
    {
      data: {
        bar: ['ADID_PAIRING', 'NEW_ADID'],
        line: ['ACT_ADID'],
        individually: true,
      },
      yAxisData: {
        left: { ACT_ADID: true },
        right: { ADID_PAIRING: true, NEW_ADID: true },
        individually: true,
      },
      customizeData: {
        NEW_ADID: { keyLabel: t('ADID_신규') },
        ACT_ADID: { keyLabel: t('ADID_활성화') },
        ADID_PAIRING: { keyLabel: t('아이디페어링') },
      },
    },
  ];

  const extraCustomized = {
    TRGT_MOB_SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: t('결제매출') + '(' + t('쇼핑') + ')',
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const firstItem = getHeadObj(headsMap, 'TRGT_MOB_SESSION_ROAS');
        const twoItems = getHeadObj(headsMap, 'TRGT_MOB_SESSION_ORDER_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['TRGT_MOB_SESSION_ROAS'],
              firstItem.type,
              firstItem.format
            )}
            <br />
            {makeRowColumn(
              rowObj['TRGT_MOB_SESSION_ORDER_AMT'],
              twoItems.type,
              twoItems.format
            )}
          </>
        );
      },
    },
    TRGT_MOB_SESSION_ORDER_AMT: { merged: true },
    TRGT_SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: t('세션매출') + '(' + t('쇼핑') + ')',
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const firstItem = getHeadObj(headsMap, 'TRGT_SESSION_ROAS');
        const twoItems = getHeadObj(headsMap, 'TRGT_SESSION_ORDER_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['TRGT_SESSION_ROAS'],
              firstItem.type,
              firstItem.format
            )}
            <br />
            {makeRowColumn(
              rowObj['TRGT_SESSION_ORDER_AMT'],
              twoItems.type,
              twoItems.format
            )}
          </>
        );
      },
    },
    TRGT_SESSION_ORDER_AMT: { merged: true },
    TRGT_DIRECT_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: t('직접매출') + '(' + t('쇼핑') + ')',
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const firstItem = getHeadObj(headsMap, 'TRGT_DIRECT_ROAS');
        const twoItems = getHeadObj(headsMap, 'TRGT_DIRECT_ORDER_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['TRGT_DIRECT_ROAS'],
              firstItem.type,
              firstItem.format
            )}
            <br />
            {makeRowColumn(
              rowObj['TRGT_DIRECT_ORDER_AMT'],
              twoItems.type,
              twoItems.format
            )}
          </>
        );
      },
    },
    TRGT_DIRECT_ORDER_AMT: { merged: true },
    TRGT_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: t('총매출') + '(' + t('쇼핑') + ')',
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const firstItem = getHeadObj(headsMap, 'TRGT_ROAS');
        const twoItems = getHeadObj(headsMap, 'TRGT_ORDER_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['TRGT_ROAS'],
              firstItem.type,
              firstItem.format
            )}
            <br />
            {makeRowColumn(
              rowObj['TRGT_ORDER_AMT'],
              twoItems.type,
              twoItems.format
            )}
          </>
        );
      },
    },
    TRGT_ORDER_AMT: { merged: true },
  };

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="DataCenterStatus"
        tabMenuList={tabList()}
        tabs={{
          '/report/datacenter/status': {
            tabComponent: (
              <StatusStatistics
                cookieParamGraph={cookieParamGraph}
                cookieGraphList={cookieGraphList}
                appadiddayGraph={appadiddayGraph}
                adidGraphList={adidGraphList}
              />
            ),
          },
          '/report/datacenter/cookie': {
            tabComponent: <CookieStatistics graphList={cookieGraphList} />,
          },
          '/report/datacenter/appTargetingDaily': {
            tabComponent: (
              <AppTargetingDailyStatistics extraCustomized={extraCustomized} />
            ),
          },
          '/report/datacenter/appTargetingMedia': {
            tabComponent: (
              <AppTargetingMediaStatistics extraCustomized={extraCustomized} />
            ),
          },
          '/report/datacenter/appTargetingAdver': {
            tabComponent: (
              <AppTargetingAdverStatistics extraCustomized={extraCustomized} />
            ),
          },
          '/report/datacenter/adidStatus': {
            tabComponent: (
              <AdidStatusStatistics
                appadiddayGraph={appadiddayGraph}
                adidGraphList={adidGraphList}
                extraKey={{
                  uri: '/report/datacenter/adidStatus',
                }}
              />
            ),
          },
          '/report/datacenter/appStatus': {
            tabComponent: <AppStatusStatistics />,
          },
          '/report/datacenter/audience': {
            tabComponent: (
              <AudienceStatistics
                displayFilterList={displayFilterList.dataCanter.audience}
              />
            ),
          },
          '/report/datacenter/filtering': {
            tabComponent: <AppFiltering />,
          },
          // 컨버전통계 오디언스
          '/report/datacenter/audience/conversion': {
            tabComponent: (
              <ConversionAudienceListStatistics
                displayFilterList={displayFilterList.dataCanter.audience}
              />
            ),
            isPop: true,
          },
          '/report/datacenter/audience/adver': {
            tabComponent: <AudienceAdver />,
            isPop: true,
          },
        }}
      />
    </MainTemplate>
  );
};

export default DataCenter;
